import { Button, Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconPlus } from "@tabler/icons-react";

interface SubscriptionHeaderProps {
  onCreateClick: () => void;
}

export const SubscriptionHeader = ({ onCreateClick }: SubscriptionHeaderProps) => {
  return (
    <div className="al-mb-6">
      <Stack direction="row" justify="between" align="center">
        <div>
          <Typography variant="page-heading" className="al-text-gray-900 al-mb-2">
            Subscriptions
          </Typography>
          <Typography variant="body" className="al-text-gray-500">
            Manage your subscriptions to automated reports, root cause analysis, or alerts
          </Typography>
        </div>
        <Button
          size="default"
          onClick={onCreateClick}
          className="al-bg-blue-600 hover:al-bg-blue-700"
        >
          <Stack gap="sm" align="center">
            <IconPlus className="al-h-4 al-w-4 al-mr-2" />
            <Typography size="sm">Create New Subscription</Typography>
          </Stack>
        </Button>
      </Stack>
    </div>
  );
};
